import { RequestStatus } from './RequestStatus'

export default class UpdateClientTemplateRequestStatusModel {
  public status: RequestStatus
  public errorDetail: string
  public publishRequestId: string
}
